namespace Areas.Eic.Review {
    "use strict";

    export function complete() {
        const form = $("#EicForm").dxForm("instance");
        const result: any = form.validate();

        if (result.isValid) {
            const data: any = form.option("formData");
            const componentsGrid = $("#ComponentsGrid").dxDataGrid("instance");

            let iScopeEditor: any = $('#ScopeEditor').dxHtmlEditor('instance');
            let iScope = iScopeEditor.option("value");

            data.EICComponentTypes = componentsGrid.getSelectedRowKeys();
            data.Scope = iScope;

            sendRequest("/Eic/Review/Complete", JSON.stringify(data), "PUT");
        }
    }

    export function returnToRequestor() {
        const verifyReturn = window.confirm("Are you sure you would like to RETURN this record?");

        if (verifyReturn) {
            const mainForm = $("#EicForm").dxForm("instance");

            const keyId: any = mainForm.option("EicId");
            if (keyId != null) {
                sendRequest(`/Eic/Review/ReturnToRequestor/${keyId}`, "", "PUT");
            }
        }
    }
}